import { useState, useEffect, useContext } from "react";
import TableCard from "../tableCard/TableCard.jsx";

import useAxios from "../../services/useAxios.tsx";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import CustomButton from "../kits/button/CustomButton.jsx";
import { DeleteIcon } from "../kits/Icons.tsx";
import ToastCustomize from "../kits/ToastCustomize";
import Swal from "sweetalert2";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";

export default function BillsTab({ users, content, setUpdater }) {
  const { userInfo } = useContext(AuthenticationContext);

  const { execute: storeHouse } = useAxios("api2/storehouse");
  const { execute: destroyBill } = useAxios("api2/cancell_checkinout");

  const convertTimestampToDate = (timeStamp) => {
    const date = new DateObject({
      date: timeStamp * 1000,
      calendar: persian,
    });
    let showDate;
    timeStamp != "" ? (showDate = date.format()) : (showDate = "-");
    return showDate;
  };

  const [header, setHeader] = useState([
    { title: "نام محصول", type: "title", name: "title" },
    { title: "نوع قبض", type: "title", name: "type" },
    { title: "تعداد", type: "title", name: "count" },
    { title: "نام کاربر", type: "title", name: "username" },
    { title: "تاریخ ثبت", type: "title", name: "date" },
    { title: "عملیات", type: "operation", name: "operation" },
  ]);

  // const [content, setContent] = useState([]);
  // useEffect(() => {
  //   storeHouse().then(data => {
  //     setContent(data.checkInOut);
  //   });
  // }, [billUpdater]);
  const destroy = (data) => {
    Swal.fire({
      title: "آیا قبض مورد نظرتان باطل شود؟",
      showDenyButton: true,
      confirmButtonText: "بله",
      denyButtonText: `خیر`,
    }).then((result) => {
      if (result.isConfirmed) {
        destroyBill({ check_id: data.check_in_out__id }).then((data) => {
          if (data.status == 1) {
            ToastCustomize({
              mainText: "قبض باطل شد",
              duration: 3000,
              toastType: "warning",
              color: "warning",
              position: "top-center",
              hasHeader: false,
            });
            setUpdater((prev) => !prev);
          }
        });
      }
    });
  };
  function action(data) {
    return (
      <>
        {userInfo.userRoll.includes(41) && (
          <div className="d-flex justify-content-center">
            {data.status == 1 ? (
              <CustomTooltip
                placement="top"
                title="ابطال قبض"
                color="secondary_custom"
              >
                <div>
                  <CustomButton
                    className="shadow-none"
                    // state={data.status == 1 ? "normal" : "deactive"}
                    // type="text"
                    onClick={() => {
                      destroy(data);
                    }}
                  >
                    <DeleteIcon color="white" />
                  </CustomButton>
                </div>
              </CustomTooltip>
            ) : (
              <div>قبض باطل شده است. </div>
            )}
          </div>
        )}
      </>
    );
  }

  return (
    <div>
      {content?.length > 0 ? (
        content.map((v) => {
          // console.log(
          //   users.filter(value => value.value == v.sender_id)[0]?.label
          // );
          return (
            <TableCard
              column={header}
              content={{
                ...v,
                date: convertTimestampToDate(v.do_tm),
                username:
                  v.type == "1"
                    ? users.filter((value) => value.value == v.sender_id)[0]
                        ?.label != undefined
                      ? users.filter((value) => value.value == v.sender_id)[0]
                          .label
                      : "-"
                    : users.filter((value) => value.value == v.reciver_id)[0]
                        ?.label != undefined
                    ? users.filter((value) => value.value == v.reciver_id)[0]
                        ?.label
                    : "-",
                operation: action(v),
                type: v.type == "1" ? "ورود" : "خروج",
              }}
              widthParent="80%"
              bg={v.status == 1 ? "primary_custom" : "dark_custom"}
            ></TableCard>
          );
        })
      ) : (
        <div>قبضی با این مشخصات یافت نشد .</div>
      )}
    </div>
  );
}
